

























import { defineComponent } from '@vue/composition-api';
import Spinner from './Spinner.vue';

export default defineComponent({
  inheritAttrs: false,
  components: { Spinner },
  props: {
    title: {
      type: String,
      required: false
    },
    action: {
      type: String,
      required: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  }
});
